import { absensiImageUrl, documentUrl, profileImageUrl } from '../../helper/config';

/**
 * Image media terproteksi.
 * Pakai <img src> langsung (bukan axios/blob) supaya TIDAK kena CORS
 * cross-origin zafu.* → api-zafu.*. Cookie JWT Domain=.irfanthomi.com ikut terkirim.
 *
 * kind: 'absensi' | 'profile' | 'document' | 'url'
 */
const AuthImage = ({
    src,
    kind = 'absensi',
    alt = '',
    className = '',
    fallback = null,
    onError,
    ...imgProps
}) => {
    if (!src) {
        return fallback || (
            <div className={`flex items-center justify-center bg-gray-100 text-gray-400 text-xs ${className}`}>
                Gambar tidak tersedia
            </div>
        );
    }

    const absolute =
        kind === 'url'
            ? src
            : kind === 'profile'
                ? profileImageUrl(src)
                : kind === 'document'
                    ? documentUrl(src)
                    : src.startsWith('http') || src.startsWith('blob:') || src.startsWith('data:') || src.startsWith('/api/')
                        ? src
                        : absensiImageUrl(src);

    return (
        <img
            {...imgProps}
            src={absolute}
            alt={alt}
            className={className}
            referrerPolicy="strict-origin-when-cross-origin"
            onError={(e) => {
                e.currentTarget.src =
                    'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="400" height="300"%3E%3Crect width="400" height="300" fill="%23f3f4f6"/%3E%3Ctext x="50%25" y="50%25" text-anchor="middle" dy=".3em" fill="%23999"%3EGambar tidak ditemukan%3C/text%3E%3C/svg%3E';
                onError?.(e);
            }}
        />
    );
};

export default AuthImage;
